module.exports = __webpack_public_path__ + "img/Departures-Front-2-small.383e9268.jpeg";